module.exports = __webpack_public_path__ + "static/media/twitter.8849d30f.png";